import { render, staticRenderFns } from "./FormRL02_3.vue?vue&type=template&id=485aee90"
import script from "./FormRL02_3.vue?vue&type=script&lang=js"
export * from "./FormRL02_3.vue?vue&type=script&lang=js"
import style0 from "./FormRL02_3.vue?vue&type=style&index=0&id=485aee90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports